import { FC, Suspense, lazy } from 'react';
import { Spin } from 'antd';
// Type-only import: erased at build time, so it does not pull CKEditor back into this chunk.
// Turning it into a value import would silently undo the code split.
import type { RichTextEditorProps } from './rich-text-editor';

const RichTextEditor = lazy(() => import('./rich-text-editor'));

/** Fetches the ~332 KB (gzipped) editor chunk on first render of a rich-text form. */
export const RichTextEditorLazy: FC<RichTextEditorProps> = (props) => (
  <Suspense fallback={<Spin style={{ display: 'block', padding: '40px 0', textAlign: 'center' }} />}>
    <RichTextEditor {...props} />
  </Suspense>
);
